import { ModalExt } from "@crispico/foundation-react/components/ModalExt/ModalExt";
import { IActionParam, IActionParamForRun } from "@crispico/react-timeline-10000/types/components/ContextMenu/IAction";
import { AbstractAction, AbstractActionLocalState, AbstractActionProps } from "components/ContextMenuRegistry";
import { AssignTasksToResourcePageProps, AssignTasksToResourcePageRRC } from "pages/gantt/AssignTasksToResourcePage";
import { Modal, ModalHeader } from "semantic-ui-react";

type AssignTasksToResourceActionLocalState = AbstractActionLocalState & {
    assignTasksToResourcePageProps: AssignTasksToResourcePageProps | undefined;
}

type AssignTasksToResourceActionProps = AbstractActionProps & {
    hideTaskSelection?: boolean;
}

export class AssignTasksToResourceAction extends AbstractAction<AssignTasksToResourceActionProps, AssignTasksToResourceActionLocalState> {

    label = _msg("AssignTasksToResourceAction.label");

    constructor(props: AssignTasksToResourceActionProps) {
        super(props);
        this.state = { assignTasksToResourcePageProps: undefined };
    }

    isVisible(param: IActionParam) {
        return param.selection.length > 0 && this.getEntityName(param.selection[0]) === "Task";
    }

    async run(param: IActionParamForRun) {
        const { id } = this.props.getEntityAt(param.selection[0])!;
        this.setState({ assignTasksToResourcePageProps: { initialSelectedTaskIds: [id], taskIds: [id] } });
    }

    render() {
        return this.state.assignTasksToResourcePageProps ? <ModalExt size="tiny" style={{ whiteSpace: "pre-line" }} transparentDimmer={true}
            open={this.state.assignTasksToResourcePageProps !== undefined}
            onClose={() => this.setState({ assignTasksToResourcePageProps: undefined })}>
            <ModalHeader>{_msg("AssignTasksToResourceAction.header.label")}</ModalHeader>
            <Modal.Content className="less-padding flex-grow" style={{ maxHeight: "700px" }}>
                <AssignTasksToResourcePageRRC {...this.state.assignTasksToResourcePageProps} hideTaskSelection={this.props.hideTaskSelection} id="assignTasksToResource"
                    onCancel={() => {
                        this.state.assignTasksToResourcePageProps?.onCancel?.();
                        this.setState({ assignTasksToResourcePageProps: undefined });
                    }}
                    onAssign={(uid: string) => {
                        this.state.assignTasksToResourcePageProps?.onAssign?.(uid);
                        this.setState({ assignTasksToResourcePageProps: undefined });
                    }} />
            </Modal.Content>
        </ModalExt> : <></>;
    }
}
